import generateIcon from "../generateIcon";

const Logout = generateIcon("fas fa-sign-out-alt");

export default Logout;
